import { render, staticRenderFns } from "./panartisWayBill.vue?vue&type=template&id=40f2d6a1&"
import script from "./panartisWayBill.vue?vue&type=script&lang=js&"
export * from "./panartisWayBill.vue?vue&type=script&lang=js&"
import style0 from "./panartisWayBill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports